module.exports = __webpack_public_path__ + "img/logo_banner.9943e721.jpg";